export const UPDATE_COMMON_COMPONENT_RESPONSE = 'UPDATE_COMMON_COMPONENT_RESPONSE';

export const updateResponseCommonComponent = (option, questionKey, questionText, response) => ({
  type: UPDATE_COMMON_COMPONENT_RESPONSE,
  payload: { option, questionKey, questionText, response },
});
